import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';

function UserMenuFunc() {
  const location = useLocation();
  const navigate = useNavigate();

  return <BurgerMenu location={location} navigate={navigate} />;
}

export default UserMenuFunc;
